import React from 'react';
import { Box, Button, Typography, Link } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import ToolsHeader from '../common/ToolsHeader';
import { getIsMobileApp } from '../../utils/mobileApp';

const LoginGateway: React.FC = () => {
  const { login } = useAuth();
  const isMobileApp = getIsMobileApp();

  const handleSignIn = () => {
    login('/');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#0A0A0A',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ToolsHeader />

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        {/* Stokastic Logo */}
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/longLogo.png`}
          alt="Stokastic"
          sx={{
            height: 40,
            width: 'auto',
            mb: 4,
          }}
        />

        {/* Headline */}
        <Typography
          variant="h1"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: { xs: 28, sm: 36 },
            color: 'white',
            textAlign: 'center',
            mb: 1.5,
          }}
        >
          Sign In to DFS Tools
        </Typography>

        {/* Supporting text */}
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: 16,
            color: 'rgba(255, 255, 255, 0.6)',
            textAlign: 'center',
            mb: 4,
          }}
        >
          Contest simulations, projections, and lineup building tools
        </Typography>

        {/* Sign In Button */}
        <Button
          variant="contained"
          onClick={handleSignIn}
          sx={{
            width: { xs: '100%', sm: 300 },
            maxWidth: 300,
            py: 1.5,
            bgcolor: '#005CCE',
            color: 'white',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: 16,
            textTransform: 'none',
            borderRadius: '8px',
            mb: 3,
            '&:hover': {
              bgcolor: '#0048A8',
            },
          }}
        >
          Sign In
        </Button>

        {/* Need an Account link — hidden in mobile app (Apple Guideline 3.1.1) */}
        {!isMobileApp && (
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: 14,
              color: 'rgba(255, 255, 255, 0.6)',
            }}
          >
            Need an Account?{' '}
            <Link
              href="https://stokastic.com/pricing"
              sx={{
                color: '#4DA3FF',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              View Plans
            </Link>
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default LoginGateway;
